import React from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import DailyLogList from "./DailyLogList";
import DailyLogNew from "./DailyLogNew";
import DailyLog from "./DailyLog";

const DailyLogs = () => (
  <div>
    <Helmet>
      <title>Daily Logs</title>
    </Helmet>
    <Switch>
      <Route component={DailyLogUi} />
    </Switch>
  </div>
);

const DailyLogUi = () => (
  <div>
    <Route exact path="/projects/:id/daily-logs/" component={DailyLogList}/>
    <Switch>
      <Route path="/projects/:id/daily-logs/new" component={DailyLogNew}/>
      <Route path="/projects/:id/daily-logs/:dailyLogId" component={DailyLog}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'Daily Logs', path: `/projects/${match.params.id}/daily-logs/`}),
  DailyLogs
);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogs.js